<div class="tag-box-component">
  <div class="tag-box {{toClass()}}">
    {{state}}
  </div>
</div>
